import { rokidBaseUrl } from "@rokid/host";
import { request, type IRequest } from "@rokid/utils";
import type { IPostGetPlaygroundPluginListReq ,IPostTogglePluginShareReq} from "./plugin.d";

/**
 * 获取agent中插件列表
 */
export const getPlaygroundPluginList: IRequest<IPostGetPlaygroundPluginListReq, any> = (data) => {
  return request({
    url: `${rokidBaseUrl}/api/plugin_api/get_playground_plugin_list`,
    method: "post",
    data,
  });
};


/*打开或关闭 插件 的共享*/
export const setPluginShare = (data:IPostTogglePluginShareReq) => {
  return request({
    url: `${rokidBaseUrl}/api/plugin_api/set_plugin_share`,
    method: 'post',
    data,
  }).then((res) => res);
};